export const ASN_PROBLEM =
	'Enter a whole network number from 1 to 4294967295, like AS15169 or 15169.'

export const parseAsn = (value: string): number | null => {
	const match = /^(?:as)?(\d{1,10})$/i.exec(value.trim())
	if (!match) return null
	const number = Number(match[1])
	return number >= 1 && number <= 4294967295 ? number : null
}

export const formatAsn = (value: number): string => `AS${value}`

export const formatAsnWithName = (
	value: number,
	name?: string | null
): string =>
	name?.trim() ? `${formatAsn(value)} · ${name.trim()}` : formatAsn(value)

export const selectedAsnNames = (
	values: number[],
	names?: Record<string, string>
): Record<string, string> =>
	Object.fromEntries(
		values
			.filter((value) => names?.[String(value)]?.trim())
			.map((value) => [String(value), names![String(value)].trim()])
	)

export const asnValues = (values: string[]): number[] => {
	const parsed = values.map(parseAsn)
	if (parsed.some((value) => value === null)) throw new Error(ASN_PROBLEM)
	return [...new Set(parsed as number[])]
}

export const ispValues = (values: string[]): string[] => {
	const seen = new Set<string>()
	return values
		.map((value) => value.trim())
		.filter((value) => {
			const key = value.toLowerCase()
			if (!value || seen.has(key)) return false
			seen.add(key)
			return true
		})
}
